/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect, useContext } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import "react-datepicker/dist/react-datepicker.css";
import "../ui/stylesheets/Dashboard.css";
import "../ui/stylesheets/AdministrativeActions.css";
import SearchBar from "../ui/components/search/SearchBar";
import Provider from "../ui/components/dropdowns/Provider";
import ProviderCalendar from "../ui/components/calendar/ProviderCalendar";
import AdministrativeActions from "../ui/components/footer/AdministrativeActions";
import ServEpicSchedule from "../ui/components/services/ServEpicSchedule";
import CreatePatientModal from "../ui/components/modals/CreatePatientModal";
import classes from "./Dashboard.module.css";
import userPrefContext from "../context/userPrefContext";
import DictionaryContext from "../context/dictionaryContext";
import AuthContext from "../context/authContext";
import CompanyContext from "../context/companyContext";
// import VisitWithPrefContext from "../context/visitWithPrefContext";
import CopyUserPrefContext from "../context/copyUserPrefContext";
import LoginBoxDB from "../LoginBoxDB";
import UserPreferencesModal from "../ui/Users/UserPreferencesModal";
import { useNavigate } from "react-router-dom"

const Dashboard = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [token, setToken] = useState(null);
  const [dictDashboard, setDictDashboard] = useState([]);
  const [dictVisit, setDictVisit] = useState([]);
  const [visitWithPrefState, setVisitWithPrefState] = useState([]);
  const [tableProvider, setTableProvider] = useState(null);
  const [tableCalendar, setTableCalendar] = useState(null);
  const [triggerDashboard, setTriggerDashboard] = useState();
  const [showUserPrefModal, setShowUserPrefModal] = useState(false);
  const [showCreatePatientModal, setShowCreatePatientModal] = useState(false);

  const { setAllDictionaries } = useContext(DictionaryContext);



  const navigate = useNavigate()
//   const { setAllVisitWithPrefFunction } = useContext(VisitWithPrefContext);

  const userPrefCtx = useContext(userPrefContext);
  const authCtx = useContext(AuthContext)

//   console.log("Dashboard - authCtx", authCtx)
  const copyUserPrefCtx = useContext(CopyUserPrefContext);
  const companyCtx = useContext(CompanyContext);
  
  const {
    setAllUserPreferenceFunction,
    setBearerTokenFunction,
    setOktaUserInfoFunction,
    setAllUserDictionaries,
    setUserGroups,
  } = useContext(userPrefContext);


//   useEffect(() => {
//     //console.log("DASHBOARD COMPONENT IS MOUNTING")

//     return () => {
//         //console.log("DASHBOARD COMPONENT IS UN-MOUNTING")
//     }
// }, [])

  function detectDevice() { 
    //https://www.quora.com/Is-there-an-algorithm-in-ReactJS-to-detect-whether-the-device-is-a-phone-or-a-computer
    //This is a function to detect what kind of device is being used
    var userAgent = navigator.userAgent.toLowerCase(); 
    if (userAgent.search("iphone") > -1 || 
        //userAgent.search("ipad") > -1 || 
        //userAgent.search("ipod") > -1 || 
        userAgent.search("android") > -1) { 
        return "mobile"; 
    } else if (userAgent.search("ipad") > -1){ 
        return "ipad"; 
    }
    else { 
        return "desktop"; 
    } 
  } 

    useEffect(() => {
        // console.log("Dashboard - mounting: useEffect 1")
        // do not render if ipad or him user
        if (!!!authCtx.userInfo.is_ipad_user && !!!authCtx.userInfo.is_ipad_user) {
          //console.log(detectDevice());
          userPrefCtx.setDeviceTypeFunction(detectDevice());
            if (authCtx.authMode === 'OKTA') {
                // console.log("Dashboard - authState", authState)
                if (!authState.isAuthenticated) {
                    // When user isn't authenticated, forget all user info
                    setToken(null);
                    setUserInfo(null);
                } else {
                    setToken(oktaAuth.getAccessToken());
                    oktaAuth.getUser().then((userInfo) => {
                        setUserInfo(userInfo);
                        //  console.log("Dashboard - userInfo", userInfo)
                        setOktaUserInfoFunction(userInfo);
                    });
                
                    // set user groups in user context
                    setUserGroups(authState.accessToken.claims.groups)
                }
            } else {
                // console.log("Dashboard authCtx.isAuthenticated", authCtx.isAuthenticated, "authCtx.userInfo", authCtx.userInfo, "authCtx.token", authCtx.token)
                if (authCtx.isAuthenticated) {
                    setUserInfo(authCtx.userInfo)
                    setOktaUserInfoFunction(authCtx.userInfo);
                    setToken(authCtx.token)
                    //console.log(authCtx.token)
                } else {
                    setUserInfo(null)
                    setToken(null)
                }
            }
        }
    
    }, [authCtx, authState, oktaAuth]); // Update if authState changes

    useEffect(async () => {
        // console.log("Dashboard - mounting: useEffect 2")
        let isMounted = true
        // console.log("Dashboard - userPrefCtx", userPrefCtx)
        // do not render if ipad or him user
        if (!!!authCtx.userInfo.is_ipad_user && !!!authCtx.userInfo.is_him_user) {
            // console.log("Dashboard authCtx.userInfo", authCtx.userInfo)
            //The preferredUsername is coming from okta, this useEffect should only run when okta populates the userPref in the first UseEffect
            
            if ((token) && (userPrefCtx.familyName.length !== 0)) {
                // if (!!token && userPrefCtx.bearerToken !== token) {
                //Setting the bearertoken to context
                if (isMounted) {
                    setBearerTokenFunction(token);
                
                
                

                    //console.log(userPrefCtx.email);
                    const visitDictURL =
                        process.env.REACT_APP_SERVER + "/api/v1/dict_services/visit";
                    //   const visitWithPrefDictURL =
                    //     process.env.REACT_APP_SERVER + "/api/v1/dict_services/visit_with_pref";
                    const userPrefMeURL =
                        process.env.REACT_APP_SERVER + "/api/v1/user_preferences/me";
                
                    const headers = { Authorization: `Bearer ${token}`, mode: "no-cors", auth: authCtx.authMode };

                    try {
                        // //console.log("Dashboard authCtx", authCtx)
                        const response = await fetch(visitDictURL, { headers });
                        if (response.status === 200) {
                        const responseData = await response.json();
                        // console.log('visit dict: ', responseData)
                        // set dictionary context
                        if (isMounted) {
                            setDictVisit(responseData);
                            setAllDictionaries(responseData);
                            // userPrefCtx.userPreference = responseData.dict_modal.sort((a, b) =>
                            // a.group_id > b.group_id || a.sort_id - b.sort_id ? 1 : -1
                            // );
                        }

                        } else {
                            console.log("not 200");
                        }
                    } catch (e) {
                        // console.log(e);
                    }

                    try {
                        // if(userPrefCtx.user.first_name === undefined && userPrefCtx.user.last_name === undefined && userPrefCtx.user.preferred_username === undefined){
                        if(authCtx.authMode === 'OKTA' && userPrefCtx.user.first_name === undefined && userPrefCtx.user.last_name === undefined ) {
                            //   //console.log('userPrefCtx first, last, and preferred username are all null', userPrefCtx)

                            const userMeURL = process.env.REACT_APP_SERVER + "/api/v1/users/me"; 

                            const responseData = await fetch(userMeURL, {
                                method: "POST",
                                body: JSON.stringify({
                                    "locale": userPrefCtx.locale,
                                    "email": userPrefCtx.email,
                                    "preferred_username": userPrefCtx.preferredUsername,
                                    "first_name": userPrefCtx.givenName,
                                    "last_name": userPrefCtx.familyName,
                                    "zoneinfo": userPrefCtx.zoneInfo,
                                    "email_verified": userPrefCtx.emailVerified
                                    }),
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                    auth: authCtx.authMode,
                                },
                            })
                            .then((res) => res.json())
                            .then((data) => {
                                // console.log(data);
                            })
                            .catch((err) => {
                                console.log(err.message);
                            });
                        } else {
                            //console.log(userPrefCtx.user.first_name, userPrefCtx.user.last_name, userPrefCtx.user.preferred_username)
                        }
                    } catch (e) {
                        // console.log(e);
                    }
                    try {
                        // if(userPrefCtx.user.first_name === undefined && userPrefCtx.user.last_name === undefined && userPrefCtx.user.preferred_username === undefined){
                        if(userPrefCtx.user.first_name === undefined && userPrefCtx.user.last_name === undefined ){
                            // console.log("Dshboar - get User Pref")
                            const response = await fetch(userPrefMeURL, { headers });
                            if (response.status === 200) {
                                const responseData = await response.json();
                                if(isMounted) {
                                    // important!!!
                                    // due to Python nature arrays of strings returned not as correct json - they have single quotes around array elements
                                    // instead of double quotes
                                    // so array properties of UserPreference object are strings. We are going to fix it here and load them as arrays
                                    let userPreference = responseData.UserPreference
                                    if (!!responseData.UserPreference) {
                                        // console.log("Dashboard - process user prefs return")
                                        //console.log('userpref dict: ', responseData)
                                        Object.keys(userPreference).forEach(key => {
                                            if (typeof userPreference[key] === "string" && userPreference[key].startsWith('[')) {
                                                userPreference[key] = JSON.parse(userPreference[key].replace(/'/g, '"'))
                                            }
                                        })
                                        // console.log("Dashboard UserPref response (/api/v1/user_preferences/me)", {...responseData, UserPreference: userPreference})
                                        setAllUserPreferenceFunction({...responseData, UserPreference: userPreference});
                                    } else {
                                        // console.log("Dashboard - show user prefs dialog")
                                        setShowUserPrefModal(true)
                                    }
                                }
                        
                                
                                //console.log("userPrefMeURL RESPONSE: ", responseData)
                                //console.log('IN THE DASHBOARD _ CTX - ', setAllUserPreferenceFunction);
                            } else {
                                console.log("not 200, userPrefMeURL failed");
                            }
                        }
                    } catch (e) {
                        // console.log(e);
                    }
                }
            } //Added copyUserPrefCtx as a trigger to the useEffect so that when there is a change in userpreference tab, there is a change in the dashboard as well
        }
        return () => {
            // console.log("Dashboard - un-mounting: useEffect 2")
            isMounted = false
        }
    }, [token, userPrefCtx.familyName, triggerDashboard, copyUserPrefCtx.userPreference, authCtx]);


  const login = async () => {
    oktaAuth.signInWithRedirect();
  };

  if (authState.isPending) {
    return <div>Loading...</div>;
  }

  const getProvider = (e) => {
    // This is getting the provider id from the child component
    setTableProvider(e);
    //console.log(e);

    sendProvAndCalendarToPatch(e)
  };

  const getCalendar = (e) => {
    // This is getting the date from the child component
    // This is to get the date into format to send to the api
    var strDate = e.toLocaleDateString("en-US");
    setTableCalendar(strDate);
    // console.log("getCalendar - strDate", strDate)
    strDate = strDate.split("/");
    var dateResult = strDate[2] + "-" + strDate[0] + "-" + strDate[1];
    // setTableCalendar(dateResult);
    // setTableCalendar(strDate);
    
    sendProvAndCalendarToPatch(e)
  };

  const sendProvAndCalendarToPatch = (e) => {

    //console.log('sendProvAndCalendarToPatch function: ', tableCalendar, tableProvider)

  }

  const getAdminActionsData = (data) => {
    //This will set the useState to trigger the useEffect
    setTriggerDashboard(data);

    //console.log(data);
  }

  // do not render dashboard for him and ipad users
//   console.log("Dashboard - userInfo", userInfo)
//   console.log("Dashboard - authCtx", authCtx)
  if (authCtx.userInfo?.is_ipad_user || authCtx.userInfo?.is_him_user) {
    return <></>
  }

  const openCreatePatientModal = () => {
    setShowCreatePatientModal(true);
  }
  const closeCreatePatientModal = () => {
    setShowCreatePatientModal(false);
  }


    const logout = () => {
        if (authCtx.authMode === 'OKTA') {
            oktaAuth.signOut()
        } else {
            try {
                localStorage.removeItem("db-auth-access-return")
                authCtx.logout()
                // force logout on App
                // props.onModeChange('main')
            }
            catch(e) {
                console.log(e)
            }
        }
        navigate('/')
    } 

  return (
    <>
    {showUserPrefModal ?
        <UserPreferencesModal show={showUserPrefModal} onHide={() => setShowUserPrefModal(false)} onLogout={logout} mode={'new user'}  />
    :
     
    <div className={classes.dash}>
      <Container>
        <div>
          {((authCtx.authMode === 'OKTA' && authState.isAuthenticated && !userInfo) || 
            (authCtx.authMode !== 'OKTA' && authCtx.isAuthenticated && !userInfo)) && 
          
            <div>Loading...</div>
          }

          {((authCtx.authMode !== 'OKTA' && authCtx.isAuthenticated) 
            ||
            (authCtx.authMode === 'OKTA' && authState.isAuthenticated && userInfo && userPrefCtx.userGroups.indexOf(process.env.REACT_APP_MAIN_APP_GROUP) >= 0 )
            )
             && (
            <div>
              <div className="dashboard_before_footer">
                <div>
                  <h3 className="patient_search_header">Patient Search</h3>
                  <div className="row search_row_div">
                    <div className="col-sm-8 col-md-12 col-lg-8 div_dashboard_search">
                    <SearchBar sendBearerToken={token} />
                    </div>
                    {companyCtx.company?.patient_search_mode === 'DB' &&
                    <div className="col-sm-8 col-md-12 col-lg-8 div_dashboard_search">
                    <p className="createpatientuppertext" >&nbsp;</p>
                      <Button onClick={openCreatePatientModal}>Create Patient</Button>
                      {showCreatePatientModal &&
                      <CreatePatientModal 
                              setOpen={showCreatePatientModal}
                              close={closeCreatePatientModal}
                      />
                    }
                    </div>
                    }
                  </div>
                    <div className="row dropdown_row_div">
                      <div 
                        className="col-sm-2 col-md-1 col-lg-2 div_blank_space"
                      >
                      </div>
                      {companyCtx.company?.show_prov_appts === true &&
                      <div className="col-sm-2 col-md-3 col-lg-2">
                        <Provider
                          func={getProvider}
                        />
                        </div>
                        }
                      {companyCtx.company?.show_prov_appts === true &&
                      <div className="col-sm-2 col-md-3 col-lg-2">
                        <ProviderCalendar func={getCalendar} />
                      </div>
                      }
                  </div>
                </div>

                {/* This is the table for the Provider Calendar*/}
                {!!companyCtx.company?.show_prov_appts &&
                    <div className="provider_calendar_div">
                        <ServEpicSchedule
                        sendProvider={tableProvider}
                        sendCalendar={tableCalendar}
                        sendBearerToken={token}
                        />
                    </div>
                }
              </div>

              <div className="admin_action_style">
                <AdministrativeActions 
                  // sendDictDashboard={visitWithPrefState} 
                  sendDictDashboard={dictVisit} 
                  sendToParent={getAdminActionsData}
                />
              </div>
            </div>
          )}

          {authCtx.authMode === 'OKTA' && !authState.isAuthenticated && (
            <div className="preauth_login_button_position">
              <Button id="login-button" variant='primary' onClick={login}>
                Login
              </Button>
            </div>
          )}

        {/* {authState.isAuthenticated && userInfo && userPrefCtx.userGroups.indexOf(process.env.REACT_APP_HIM_GROUP) >= 0 && 
            <Him />
        } */}
        </div>
      </Container>
    </div>
    }

    {/* <LoginBoxDB authMode={authCtx.authMode} mode='autolock' showMessage="You've been locked out due to inactivity. Sign in to unlock your session" /> */}
    </>
  );
};
export default Dashboard;
